export default __webpack_public_path__ + "static/media/ananses3m.bae9cc29.jpg";